import React from "react";
import { FaFacebook, FaInstagram, FaYoutube,FaTiktok } from "react-icons/fa6";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <footer className="footer flex flex-col sm:flex-row items-center justify-center sm:justify-evenly p-10 text-white">
        <div className="flex flex-col md:flex-row justify-center items-center srsfooter mt-5 ">
          <img src="/srslogo.png" alt="Picture of the author" />
          <p className="text-center text-xs mt-2 sm:mt-0 sm:ml-4">
            Salt River Shakedown
            <br />
            All rights reserved 
            &copy; {currentYear}
            
          </p>
        </div>

        <div className="flex justify-center gap-3 mt-8 sm:mt-0">
          <a
            href="https://www.facebook.com/saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.instagram.com/saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.youtube.com/@SaltRiverShakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.tiktok.com/@saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="text-white text-4xl hover:scale-110" />
          </a>
        </div>

        <div className="flex justify-center text-xs sm:text-md gap-3 mt-8 sm:mt-0 hover:conjury">
          <a
            href="https://www.conjury.dev"
            target="blank"
            className=" hover:scale-105 duration-100 ease-in-out hover:text-srs-pink"
          >
            &copy; {currentYear} | Made by Conjury{" "}
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
